import { render, staticRenderFns } from "./Inputcompany.vue?vue&type=template&id=3959ce4c&"
import script from "./Inputcompany.vue?vue&type=script&lang=js&"
export * from "./Inputcompany.vue?vue&type=script&lang=js&"
import style0 from "./Inputcompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports